import { Box, Field, Flex, Icon, Input, InputGroup, Tooltip } from '@chakra-ui/react'
import { FormErrors } from 'commons/components/layout/FormErrors'
import { Label } from 'commons/components/layout/Label'
import { Section } from 'commons/components/layout/Section'
import { useFieldContext } from 'commons/config/form'
import { BgColors, TextColors } from 'commons/design-system/tokens'
import type { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { MdInfo } from 'react-icons/md'

export const EmailSection = () => {
	const field = useFieldContext<string>()
	const { t } = useTranslation()

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		field.handleChange(e.target.value)
	}

	return (
		<Field.Root
			invalid={
				!field.state.meta.isValid || (field.state.meta.errors && field.state.meta.errors.length > 0)
			}
		>
			<Section
				_focusWithin={{ outline: `2px solid ${BgColors.OPPOSITE_Z3}` }}
				_groupInvalid={{
					outline: `2px solid ${TextColors.STATUS_ERROR}`
				}}
			>
				<Label>
					<Flex alignItems='center' gap={1}>
						<Box mb={-0.5}>{t('phone_form.email_label')}</Box>
						<Tooltip.Root positioning={{ placement: 'top' }}>
							<Tooltip.Trigger asChild>
								<Box as='span' cursor='pointer'>
									<Icon as={MdInfo} boxSize='16px' />
								</Box>
							</Tooltip.Trigger>
							<Tooltip.Positioner>
								<Tooltip.Content>
									<Tooltip.Arrow />
									{t('phone_form.email_tooltip')}
								</Tooltip.Content>
							</Tooltip.Positioner>
						</Tooltip.Root>
					</Flex>
				</Label>
				<InputGroup>
					<Input
						fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
						fontWeight={500}
						id='email'
						name='email'
						autoComplete='email'
						type='email'
						variant='unstyled'
						py={2}
						placeholder={t('phone_form.email_placeholder')}
						value={field.state.value || ''}
						onChange={handleChange}
						_focus={{ outline: 'none' }}
						_focusVisible={{ outline: 'none' }}
					/>
				</InputGroup>
				<FormErrors errors={field.state.meta.errors} />
			</Section>
		</Field.Root>
	)
}
